// extracted by mini-css-extract-plugin
module.exports = {"case":"case-module--case--1sGee","img":"case-module--img--35Y42"};